import * as types from '../types';

const initialState = {
  regions: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case types.REGION_SET_LIST:
      return {...state, regions: action.data};
    default:
      return state;
  }
}

